import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import ProgressBar from "@componentsShared/ProgressBar";
import StepTag from "@/pages/sell-my-car/components/StepTag";
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { SCREENS_HAVE_TAGS, SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { If } from "@componentsShared/Conditional/If";
import { useEffect, useRef } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
var FlowStepMeta = function FlowStepMeta(_ref) {
  var _state$draftOrder, _selection$make, _selection$make2, _selection$make3, _selection$model, _selection$model2, _selection$model3, _selection$extension, _selection$extension2, _selection$odometerRa, _selection$odometerRa2, _selection$odometerRa3;
  var title = _ref.title,
    icon = _ref.icon,
    progress = _ref.progress,
    breadcrumbs = _ref.breadcrumbs;
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions,
    screenState = _useScreenNavigation.state;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    dataActions = _useSellCarData.actions;
  var selection = state === null || state === void 0 ? void 0 : state.selection;
  var tagsRef = useRef(null);
  var lang = useLang();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  useEffect(function () {
    if (tagsRef !== null && tagsRef !== void 0 && tagsRef.current) {
      var container = tagsRef.current;
      var overflow = container.scrollWidth - container.clientWidth;
      if (overflow) {
        tagsRef.current.scrollLeft = lang == 'ar' ? -overflow : overflow;
      }
    }
  }, [selection, lang]);
  var handleBreadcrumbClick = function handleBreadcrumbClick(screenName) {
    // Clear data after this screen
    switch (screenName) {
      case SELL_CAR_SCREENS.CAR_MAKE:
        dataActions.clearFromMake();
        break;
      case SELL_CAR_SCREENS.CAR_MODEL:
        dataActions.clearFromModel();
        break;
      case SELL_CAR_SCREENS.CAR_EXTENSION:
        dataActions.clearFromExtension();
        break;
      case SELL_CAR_SCREENS.CAR_YEAR:
        dataActions.clearFromYear();
        break;
      case SELL_CAR_SCREENS.CAR_ODOMETER:
        dataActions.clearFromOdometer();
        break;
      case SELL_CAR_SCREENS.CAR_OWNERSHIP:
        dataActions.clearFromOwnership();
        break;
    }

    // Navigate and clear forward history (disable forward button)
    navActions.navigateToPreviousScreen(screenName, true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-step-meta",
    className: "flex flex-col w-full px-4 gap-4 pb-4 md:max-w-[916px] mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-step-header",
    className: "flex items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-step-icon",
    className: "p-2 flex items-center justify-center bg-blue-lavender rounded-lg shadow-[0px_0px_0.800000011920929px_0px_rgba(13,13,181,1.00)]"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    width: 6,
    height: 6,
    className: "text-primary-new"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    id: "sell-car-flow-step-title",
    className: "text-base text-black-primary font-bold"
  }, title))), /*#__PURE__*/React.createElement(ProgressBar, {
    progress: progress,
    color: "primary",
    showLabel: false,
    height: "h-1",
    background: "bg-[#bbbbc9]"
  }), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-flow-step-tags",
    className: "flex overflow-x-auto overflow-y-hidden items-center gap-2 scrollbar-hide",
    ref: tagsRef
  }, /*#__PURE__*/React.createElement(If, {
    condition: SCREENS_HAVE_TAGS.includes(screenState === null || screenState === void 0 ? void 0 : screenState.currentScreen) && !(state !== null && state !== void 0 && (_state$draftOrder = state.draftOrder) !== null && _state$draftOrder !== void 0 && _state$draftOrder.requestId) && !(state !== null && state !== void 0 && state.isOtpVisible)
  }, /*#__PURE__*/React.createElement(If, {
    condition: !!(selection !== null && selection !== void 0 && selection.make)
  }, /*#__PURE__*/React.createElement(StepTag, {
    id: "sell-car-step-tag-make",
    key: selection === null || selection === void 0 ? void 0 : (_selection$make = selection.make) === null || _selection$make === void 0 ? void 0 : _selection$make.name,
    text: lang == 'ar' ? selection === null || selection === void 0 ? void 0 : (_selection$make2 = selection.make) === null || _selection$make2 === void 0 ? void 0 : _selection$make2.name : selection === null || selection === void 0 ? void 0 : (_selection$make3 = selection.make) === null || _selection$make3 === void 0 ? void 0 : _selection$make3.seo_url,
    onClick: function onClick() {
      var url = new URL(window.location.href);
      url.searchParams["delete"]('make_id');
      window.history.replaceState({}, '', url.toString());
      handleBreadcrumbClick(SELL_CAR_SCREENS.CAR_MAKE);
    }
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!(selection !== null && selection !== void 0 && selection.model)
  }, /*#__PURE__*/React.createElement(StepTag, {
    id: "sell-car-step-tag-model",
    key: selection === null || selection === void 0 ? void 0 : (_selection$model = selection.model) === null || _selection$model === void 0 ? void 0 : _selection$model.name,
    text: lang == 'ar' ? selection === null || selection === void 0 ? void 0 : (_selection$model2 = selection.model) === null || _selection$model2 === void 0 ? void 0 : _selection$model2.name : selection === null || selection === void 0 ? void 0 : (_selection$model3 = selection.model) === null || _selection$model3 === void 0 ? void 0 : _selection$model3.seo_name,
    onClick: function onClick() {
      return handleBreadcrumbClick(SELL_CAR_SCREENS.CAR_MODEL);
    }
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!(selection !== null && selection !== void 0 && selection.extension)
  }, /*#__PURE__*/React.createElement(StepTag, {
    id: "sell-car-step-tag-trim",
    key: selection === null || selection === void 0 ? void 0 : (_selection$extension = selection.extension) === null || _selection$extension === void 0 ? void 0 : _selection$extension.name,
    text: selection === null || selection === void 0 ? void 0 : (_selection$extension2 = selection.extension) === null || _selection$extension2 === void 0 ? void 0 : _selection$extension2.name,
    onClick: function onClick() {
      return handleBreadcrumbClick(SELL_CAR_SCREENS.CAR_EXTENSION);
    }
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!(selection !== null && selection !== void 0 && selection.year)
  }, /*#__PURE__*/React.createElement(StepTag, {
    id: "sell-car-step-tag-year",
    key: selection === null || selection === void 0 ? void 0 : selection.year,
    text: selection === null || selection === void 0 ? void 0 : selection.year,
    onClick: function onClick() {
      return handleBreadcrumbClick(SELL_CAR_SCREENS.CAR_YEAR);
    }
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!(selection !== null && selection !== void 0 && selection.odometerRange)
  }, /*#__PURE__*/React.createElement(StepTag, {
    id: "sell-car-step-tag-odometer",
    key: selection === null || selection === void 0 ? void 0 : (_selection$odometerRa = selection.odometerRange) === null || _selection$odometerRa === void 0 ? void 0 : _selection$odometerRa.range_ar,
    text: lang == 'ar' ? selection === null || selection === void 0 ? void 0 : (_selection$odometerRa2 = selection.odometerRange) === null || _selection$odometerRa2 === void 0 ? void 0 : _selection$odometerRa2.range_ar : selection === null || selection === void 0 ? void 0 : (_selection$odometerRa3 = selection.odometerRange) === null || _selection$odometerRa3 === void 0 ? void 0 : _selection$odometerRa3.range,
    onClick: function onClick() {
      return handleBreadcrumbClick(SELL_CAR_SCREENS.CAR_ODOMETER);
    }
  })), /*#__PURE__*/React.createElement(If, {
    condition: !!(selection !== null && selection !== void 0 && selection.ownership)
  }, /*#__PURE__*/React.createElement(StepTag, {
    id: "sell-car-step-tag-ownership",
    key: selection === null || selection === void 0 ? void 0 : selection.ownership,
    text: (selection === null || selection === void 0 ? void 0 : selection.ownership) === 'Owned' ? tShort("sell_trade_v2/ownership_owned", {
      ns: "web_sell_trade"
    }) : tShort("sell_trade_v2/ownership_not_owned", {
      ns: "web_sell_trade"
    }),
    onClick: function onClick() {
      return handleBreadcrumbClick(SELL_CAR_SCREENS.CAR_OWNERSHIP);
    }
  }))))));
};
export default FlowStepMeta;